import * as React from 'react';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { IEntityDTO } from '../../Domain/IEntityDTO';
import { VolmaContainer } from '../../Infrastructure/InversifyInject';
import { volmaBlock } from '../../Infrastructure/Services/BEM';
import { Types } from '../../Infrastructure/Types';
import { IGlobalState } from '../../Reducers/IGlobalState';
import i18next from '../i18n';
import { IVolmaModalProps } from './IVolmaModalProps';
import { IVolmaModalConfirmPayload } from './Payloads';
import { VolmaModalActions } from './VolmaModalActions';

class VolmaModalConfirm extends Component<IVolmaModalProps<IEntityDTO, any>, {}>{
    private _modalActions: VolmaModalActions;
    private _text: string;
    private _header: string;
    private _onConfirmed: () => void;
    private _onDeclined: () => void;

    private _modal        = volmaBlock("modal");
    private _modalWrap    = volmaBlock("modal-wrap");
    private _modalConfirm = volmaBlock("modal-confirm");
    private _lightInput   = volmaBlock("light-input");
    private _btnModal     = volmaBlock("btn-modal");

    constructor(props: IVolmaModalProps<any, any>, context: any) {
        super(props, context);

        this._modalActions = VolmaContainer.get<VolmaModalActions>(Types.VolmaModalActions);

        const state = this.props.Props as IVolmaModalConfirmPayload;
        this._text = state.Text;
        this._onConfirmed = state.OnConfirmed;
        this._onDeclined = state.OnDeclined;
    }

    public render() {
        return (
            <div className={(this._modal.mix(["active"])).toString()}>
                <div className={(this._modalWrap).toString()}>
                    <div className={(this._modalConfirm).toString()}>
                        <form className={(this._modalConfirm("form")).toString()}>
                            <div className={(this._modalConfirm("form-row")).toString()}>
                                <div className={(this._modalConfirm("form-cell", {full: true })).toString()}>
                                    <div className={(this._modalConfirm("form-text")).toString()}>
                                        {i18next.t(this._text)}
                                    </div>
                                </div>
                            </div>

                            <div className={(this._modalConfirm("form-row")).toString()}>
                                <div className={(this._modalConfirm("form-cell")).toString()}>
                                    <button onClick={this.OnOkClick.bind(this)} className={(this._btnModal({large: true, green: true }).mix(["btn"])).toString()}>{i18next.t('common:ButtonYes')}</button>
                                </div>
                                <div className={(this._modalConfirm("form-cell")).toString()}>
                                    <button onClick={this.OnCancelClick.bind(this)} className={(this._btnModal({large: true, red: true }).mix(["btn"])).toString()}>{i18next.t('common:ButtonNo')}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div >

            /*<Modal open={true} onClose={() => this.OnCancelClick()}>
                <div>
                    <p>{i18next.t(this._text)}</p>
                    <VolmaButton label={i18next.t('common:ButtonOk')} onClick={this.OnOkClick.bind(this)} />
                    <VolmaButton label={i18next.t('common:ButtonCancel')} onClick={this.OnCancelClick.bind(this)} />
                </div>
            </Modal>*/
        )
    }

    private OnOkClick() {
        this._onConfirmed();
        this.props.dispatch(this._modalActions.CloseModal())
    }

    private OnCancelClick() {
        this._onDeclined();
        this.props.dispatch(this._modalActions.CloseModal());
    }

}

const translated = withTranslation(['common'])(withRouter(VolmaModalConfirm));


function select(state: IGlobalState, ownProps: IVolmaModalProps<any, any>): IVolmaModalProps<any, any> {
    return state.ModalEntity;
}



export const ConnectedVolmaModalConfirm = connect<IVolmaModalProps<any, any>, {}, {}>(select)(translated);